import { Button } from "@/components/ui/button";

interface GuestOrWaitlistSectionProps {
  anonymousEnabled: boolean | null;
  isLoading: boolean;
  onContinue: () => void;
}

export const GuestOrWaitlistSection = ({
  anonymousEnabled,
  isLoading,
  onContinue,
}: GuestOrWaitlistSectionProps) => {
  if (anonymousEnabled === null) {
    return (
      <div className="mt-6 text-center">
        <p className="text-sm text-muted-foreground">Checking access options...</p>
      </div>
    );
  }

  return (
    <div className="mt-6 text-center">
      <p className="text-sm text-muted-foreground mb-2">
        {anonymousEnabled ? "Don't want to sign in?" : "Don't have an account yet?"}
      </p>
      <Button 
        variant="outline" 
        className="w-full"
        onClick={onContinue}
        disabled={isLoading}
      >
        {anonymousEnabled ? "Continue as Guest" : "Join Waitlist"}
      </Button>
    </div>
  );
};
